import axios from "../api/axiosInstance";

function buildParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export async function fetchCrmDashboard() {
  const response = await axios.get("/api/crm/dashboard");
  return response.data;
}

export async function fetchCrmCompanies(params = {}) {
  const response = await axios.get("/api/crm/companies", { params: buildParams(params) });
  return response.data;
}

export async function fetchCrmCompany(id) {
  const response = await axios.get(`/api/crm/companies/${id}`);
  return response.data;
}

export async function createCrmCompany(payload) {
  const response = await axios.post("/api/crm/companies", payload);
  return response.data;
}

export async function updateCrmCompany(id, payload) {
  const response = await axios.patch(`/api/crm/companies/${id}`, payload);
  return response.data;
}

export async function mergeCrmCompanies(payload) {
  const response = await axios.post("/api/crm/companies/merge", payload);
  return response.data;
}

export async function unmergeCrmCompany(id, payload = {}) {
  const response = await axios.post(`/api/crm/companies/${id}/unmerge`, payload);
  return response.data;
}

export async function fetchCrmContacts(params = {}) {
  const response = await axios.get("/api/crm/contacts", { params: buildParams(params) });
  return response.data;
}

export async function fetchCrmContact(id) {
  const response = await axios.get(`/api/crm/contacts/${id}`);
  return response.data;
}

export async function createCrmContact(payload) {
  const response = await axios.post("/api/crm/contacts", payload);
  return response.data;
}

export async function updateCrmContact(id, payload) {
  const response = await axios.patch(`/api/crm/contacts/${id}`, payload);
  return response.data;
}

export async function mergeCrmContacts(payload) {
  const response = await axios.post("/api/crm/contacts/merge", payload);
  return response.data;
}

export async function unmergeCrmContact(id, payload = {}) {
  const response = await axios.post(`/api/crm/contacts/${id}/unmerge`, payload);
  return response.data;
}

export async function fetchCrmLeads(params = {}) {
  const response = await axios.get("/api/crm/leads", { params: buildParams(params) });
  return response.data;
}

export async function fetchCrmLead(id) {
  const response = await axios.get(`/api/crm/leads/${id}`);
  return response.data;
}

export async function fetchCrmAssignableUsers() {
  const response = await axios.get("/api/crm/users/assignable");
  return response.data;
}

export async function createCrmLead(payload) {
  const response = await axios.post("/api/crm/leads", payload);
  return response.data;
}

export async function updateCrmLead(id, payload) {
  const response = await axios.patch(`/api/crm/leads/${id}`, payload);
  return response.data;
}

export async function mergeCrmLeads(payload) {
  const response = await axios.post("/api/crm/leads/merge", payload);
  return response.data;
}

export async function unmergeCrmLead(id, payload = {}) {
  const response = await axios.post(`/api/crm/leads/${id}/unmerge`, payload);
  return response.data;
}

export async function assignCrmLead(id, ownerUserId) {
  const response = await axios.patch(`/api/crm/leads/${id}/assignment`, {
    owner_user_id: ownerUserId,
  });
  return response.data;
}

export async function fetchCrmLeadAssignmentHistory(id) {
  const response = await axios.get(`/api/crm/leads/${id}/assignment-history`);
  return response.data;
}

export async function fetchCrmLeadPipelineHistory(id) {
  const response = await axios.get(`/api/crm/leads/${id}/pipeline-history`);
  return response.data;
}

export async function fetchCrmOpportunityPipelines(params = {}) {
  const response = await axios.get("/api/crm/opportunity-pipelines", { params: buildParams(params) });
  return response.data;
}

export async function createCrmOpportunityPipeline(payload) {
  const response = await axios.post("/api/crm/opportunity-pipelines", payload);
  return response.data;
}

export async function updateCrmOpportunityPipeline(id, payload) {
  const response = await axios.patch(`/api/crm/opportunity-pipelines/${id}`, payload);
  return response.data;
}

export async function importCrmLeads(payload) {
  const response = await axios.post("/api/crm/leads/import", payload);
  return response.data;
}

export async function fetchCrmTasks(params = {}) {
  const response = await axios.get("/api/crm/tasks", { params: buildParams(params) });
  return response.data;
}

export async function fetchCrmTask(id) {
  const response = await axios.get(`/api/crm/tasks/${id}`);
  return response.data;
}

export async function fetchCrmDueTaskReminders() {
  const response = await axios.get("/api/crm/tasks/reminders/due");
  return response.data;
}

export async function createCrmTask(payload) {
  const response = await axios.post("/api/crm/tasks", payload);
  return response.data;
}

export async function updateCrmTask(id, payload) {
  const response = await axios.patch(`/api/crm/tasks/${id}`, payload);
  return response.data;
}

export async function acknowledgeCrmTaskReminder(id) {
  const response = await axios.patch(`/api/crm/tasks/${id}/reminder-acknowledge`);
  return response.data;
}

export async function fetchCrmConversations(params = {}) {
  const response = await axios.get("/api/crm/conversations", { params: buildParams(params) });
  return response.data;
}

export async function createCrmConversation(payload) {
  const response = await axios.post("/api/crm/conversations", payload);
  return response.data;
}

export async function fetchCrmConversation(id) {
  const response = await axios.get(`/api/crm/conversations/${id}`);
  return response.data;
}

export async function relinkCrmConversationContact(id) {
  const response = await axios.post(`/api/crm/conversations/${id}/relink-contact`);
  return response.data;
}

export async function createCrmConversationMessage(conversationId, payload) {
  const response = await axios.post(`/api/crm/conversations/${conversationId}/messages`, payload);
  return response.data;
}

export async function sendCrmWhatsAppMessage(conversationId, payload) {
  const response = await axios.post(`/api/crm/conversations/${conversationId}/whatsapp/messages`, payload);
  return response.data;
}

export async function sendCrmWhatsAppTemplate(conversationId, payload) {
  const response = await axios.post(`/api/crm/conversations/${conversationId}/whatsapp/templates`, payload);
  return response.data;
}

export async function startCrmWhatsAppConversation(payload) {
  const response = await axios.post("/api/crm/whatsapp/conversations/start", payload);
  return response.data;
}

export async function createCrmConversationSummary(conversationId, payload = {}) {
  const response = await axios.post(`/api/crm/conversations/${conversationId}/summaries`, payload);
  return response.data;
}
